import { BoxWindow } from "../components/BoxWindow"
import { Box, Button, Card, CardBody, Notification, Spinner, Tab, Tabs, Text, TextInput } from "grommet";
import { Add, Search } from "grommet-icons";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { authenticationSelector } from "../slices/authSlice";
import { TwitchAuth } from "../components/auth/TwitchAuth";
import { useGetConfigsQuery } from "../api/configApi";
import { useTranslation } from "react-i18next";
import MemesGlobalList from "../components/memes/memes-list/MemesGlobalList";
import MemesFavoritesList from "../components/memes/memes-list/MemesFavoritesList";
import { useNavigate } from "react-router-dom";

export const MemesPage = () => {

    const { t, ready } = useTranslation('memes', {
		useSuspense: false,
	});
    const navigate = useNavigate();
    const isAuthenticated = useSelector(authenticationSelector);
    const [searchTerm, setSearchTerm] = useState();
    const [activeTab, setActiveTab] = useState(0);
    const [configSet, setConfigSet] = useState({});
    const { data: configs } = useGetConfigsQuery();

    useEffect(() => {
        setConfigSet(configs?.reduce((accum, config) => ({ ...accum, [config.configKey]: config.value }), {}));
    }, [configs])

    if (!ready) {
        return (<Spinner/>)
    }

    return (
        <Box fill>
            {/* <Notification title={<Text size="xsmall">{t('betaTestBanner')}</Text>} status="warning" global /> */}
            <BoxWindow margin={{ top: 'medium' }}>
                <Card background="#222222">
                    <CardBody pad="medium">
                        <Box direction="row" gap="small" align="center">
                            <Box flex>
                                <TextInput name="_search" icon={<Search/>} type="search" onChange={(event) => setSearchTerm(event.target.value)}/>
                            </Box>
                            <Box direction="row" gap="small" align="center">
                                {/* <SelectMultiple placeholder="Select filter" options={['Fullscreen memes', 'Spot memes', 'Mixed memes']} /> */}
                                {isAuthenticated && <Button label={t('memeCreateButton')} icon={<Add/>} onClick={() => navigate('/memes/create')} disabled={configSet && configSet['interactions.upload.enabled'] === "false"} />}
                                {!isAuthenticated && <TwitchAuth />}
                            </Box>
                        </Box>
                    </CardBody>
                </Card>
            </BoxWindow>
            {/* <BoxWindow bottomPadding={false}>
                <MemesTags tags={tags} />
            </BoxWindow> */}
            <BoxWindow>
                <Tabs alignControls="end" onActive={setActiveTab}>
                    <Tab title={t('tabMemesTitle')}>
                        <MemesGlobalList searchTerm={searchTerm} activeTab={activeTab} />
                    </Tab>
                    {isAuthenticated && <Tab title={t('tabFavoritesTitle')}>
                        <MemesFavoritesList searchTerm={searchTerm} activeTab={activeTab} />
                    </Tab>}
                </Tabs>
            </BoxWindow>
        </Box>
    )
}